<template>
  <div class="cold-setting">
    <el-table :data="formatedList">
      <el-table-column label="币种" prop="coinType"> </el-table-column>
      <el-table-column label="阈值" prop="threshold">
        <template slot-scope="scope">
          <a @click="handlePrecisionChange(scope.row.coinType)">
            {{ scope.row.threshold }}
            <i class="el-icon-edit"></i>
          </a>
        </template>
      </el-table-column>
      <el-table-column label="手续费" prop="fee">
        <template slot-scope="scope">
          {{ scope.row.fee }}
          <i class="el-icon-edit" @click="editFees(scope.row.coinType)"></i>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="danger"
            icon="el-icon-delete"
            circle
            size="small"
            @click="handleRemove(scope.row.coinType)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('coldSetting', ['formatedList'])
  },
  methods: {
    ...mapActions('coldSetting', [
      'getList',
      'getFee',
      'deteleCold',
      'addCold',
      'editFee'
    ]),
    handlePrecisionChange(pair) {
      this.$prompt('阈值', '提示', {
        inputValidator: value => {
          return !value || !value.trim() ? '阈值' : true;
        }
      }).then(({ value }) => {
        this.addCold({ coinType: pair, value: Number(value) }).then(() => {
          this.$message.success('操作成功！');
          this.getList();
          this.getFee();
        });
      });
    },
    editFees(coinType) {
      this.$prompt('手续费', '提示', {
        inputValidator: value => {
          return !value || !value.trim() ? '手续费' : true;
        }
      }).then(({ value }) => {
        this.editFee({ coinType: coinType, value: Number(value) }).then(() => {
          this.$message.success('操作成功！');
          this.getList();
          this.getFee();
        });
      });
    },
    handleRemove(coinType) {
      const message = '确定删除该配置吗';
      this.$confirm(message, '提示', {
        type: 'warning'
      }).then(() => {
        this.deteleCold({
          coinType: coinType
        }).then(() => {
          this.$message.success('删除成功！');
          this.getList();
          this.getFee();
        });
      });
    }
  },
  mounted() {
    this.getList();
    this.getFee();
  }
};
</script>
<style lang="less" scoped></style>
